<template lang="pug">
    div.cart
        div.container-fluid
            div.row
                div.col
                    CartVue(ref="cartvue")
                    LoginVue(@cart-change="cartReload")
                    StripeVue(v-if="$store.state.auth.loggedin && $store.state.auth.role=='user'")
                    div.container-fluid(style="padding-bottom: 30px; padding-top: 25px;",v-show="$store.state.auth.loggedin && $store.state.auth.role!='user'")
                        div.row.justify-content-center
                            div.col-9.form-colored
                                label.text-danger Writerアカウントではエッセイの購入はできません。
                                
                    
</template>


<script>
import CartVue from "@/components/CartVue.vue"
import StripeVue from "@/components/StripeVue.vue"
import LoginVue from "@/components/LoginVue.vue"

export default {
  name: 'Cart',
  components: {
      CartVue,
      StripeVue,
      LoginVue,
  },
  head: {
    title: {
      inner: 'Cart'
    },
    meta: [
      { name:"robots", content:"none"},
      { name:"description", content:""}
    ]
  },
  data (){
      return {
          }
  },
  methods:{
      cartReload (){
          this.$refs.cartvue.reload();
      }
  }
}
</script>



<style scoped>
.form-colored {
  text-align: left;
  background-color: rgb(247, 250, 252);
  padding: 20px;
}

</style>